"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Trybe
 * This site provides documentation on how to use the Trybe Shop API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var runtime_1 = require("../runtime");
var _1 = require("./");
/**
* @export
* @enum {string}
*/
var InventoryOrderWithItemsStatusEnum;
(function (InventoryOrderWithItemsStatusEnum) {
    InventoryOrderWithItemsStatusEnum["Draft"] = "draft";
    InventoryOrderWithItemsStatusEnum["Submitted"] = "submitted";
    InventoryOrderWithItemsStatusEnum["Received"] = "received";
})(InventoryOrderWithItemsStatusEnum = exports.InventoryOrderWithItemsStatusEnum || (exports.InventoryOrderWithItemsStatusEnum = {}));
function InventoryOrderWithItemsFromJSON(json) {
    return InventoryOrderWithItemsFromJSONTyped(json, false);
}
exports.InventoryOrderWithItemsFromJSON = InventoryOrderWithItemsFromJSON;
function InventoryOrderWithItemsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'status': json['status'],
        'purchase_order_number': json['purchase_order_number'],
        'supplier_id': json['supplier_id'],
        'supplier_name': json['supplier_name'],
        'supplier_email': !runtime_1.exists(json, 'supplier_email') ? undefined : json['supplier_email'],
        'subtotal': json['subtotal'],
        'currency': json['currency'],
        'item_count': json['item_count'],
        'items': (json['items'].map(_1.InventoryOrderItemFromJSON)),
        'created_by_id': json['created_by_id'],
        'items_added': json['items_added'],
        'organisation_id': json['organisation_id'],
        'created_at': (new Date(json['created_at'])),
        'updated_at': (new Date(json['updated_at'])),
        'submitted_at': (json['submitted_at'] === null ? null : new Date(json['submitted_at'])),
        'last_submitted_at': (json['last_submitted_at'] === null ? null : new Date(json['last_submitted_at'])),
    };
}
exports.InventoryOrderWithItemsFromJSONTyped = InventoryOrderWithItemsFromJSONTyped;
function InventoryOrderWithItemsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'status': value.status,
        'purchase_order_number': value.purchase_order_number,
        'supplier_id': value.supplier_id,
        'supplier_name': value.supplier_name,
        'supplier_email': value.supplier_email,
        'subtotal': value.subtotal,
        'currency': value.currency,
        'item_count': value.item_count,
        'items': (value.items.map(_1.InventoryOrderItemToJSON)),
        'created_by_id': value.created_by_id,
        'items_added': value.items_added,
        'organisation_id': value.organisation_id,
        'created_at': (value.created_at.toISOString()),
        'updated_at': (value.updated_at.toISOString()),
        'submitted_at': (value.submitted_at === null ? null : value.submitted_at.toISOString()),
        'last_submitted_at': (value.last_submitted_at === null ? null : value.last_submitted_at.toISOString()),
    };
}
exports.InventoryOrderWithItemsToJSON = InventoryOrderWithItemsToJSON;
